const API_URL = process.env.REACT_APP_API_URL;

// Helper function to handle common fetch operations
const fetchWithAuth = async (url, options = {}) => {
  // Get the authentication token from localStorage
  const token = localStorage.getItem("token");

  // Set up headers with authentication
  const headers = {
    "Content-Type": "application/json",
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  // Perform the fetch operation
  const response = await fetch(url, {
    ...options,
    headers,
  });

  // Handle non-OK responses
  if (!response.ok) {
    throw new Error(`API Error: ${response.statusText}`);
  }

  return response.json();
};

// Events API
export const fetchEvents = async () => {
  return fetchWithAuth(`${API_URL}/events`);
};

export const getEventById = async (id) => {
  return fetchWithAuth(`${API_URL}/events/${id}`);
};

export const createEvent = async (eventData) => {
  return fetchWithAuth(`${API_URL}/events`, {
    method: "POST",
    body: JSON.stringify(eventData),
  });
};

export const updateEvent = async (id, eventData) => {
  return fetchWithAuth(`${API_URL}/events/${id}`, {
    method: "PUT",
    body: JSON.stringify(eventData),
  });
};

export const deleteEvent = async (id) => {
  return fetchWithAuth(`${API_URL}/events/${id}`, {
    method: "DELETE",
  });
};
